import type {
  ConsentType,
  Customer,
  CustomerConsent as CustomerConsentType,
  hfb,
} from "@repo/api";
import { Button } from "@repo/skapa";
import { t } from "@repo/translation";
import { ModalSheet } from "@repo/ui/src/components/ModalSheet";
import { useCustomer } from "@repo/ui/src/hooks/useCustomer";
import { useSettings } from "@repo/ui/src/settings/SettingsProvider";
import { isDefined } from "@repo/utils";
import isEqual from "lodash/isEqual";
import { useState } from "react";

import { CustomerConsent } from "./CustomerConsent";

interface ConsentModalProps {
  isOpen: boolean;
  closeModal: () => void;
  opportunityId?: number;
  customer?: Customer;
  departments?: hfb[];
  manualConsents?: CustomerConsentType[];
  onSelectConsents?: (consents?: CustomerConsentType[]) => void;
}
export const ConsentModal = ({
  isOpen,
  closeModal,
  opportunityId,
  customer,
  departments,
  manualConsents,
  onSelectConsents,
}: ConsentModalProps) => {
  const { customer: opportunityCustomer } = useCustomer(opportunityId);
  const { consent_requirements } = useSettings();

  const [localConsents, setLocalConsents] = useState<
    CustomerConsentType[] | undefined
  >(manualConsents);

  const consentTypes = [
    "FOLLOWUP_CONSENT",
    consent_requirements?.promotional_consent
      ? "PROMOTIONAL_CONSENT"
      : undefined,
  ].filter(isDefined) as ConsentType[];

  return (
    <ModalSheet
      title={t("label.customer_consent")}
      visible={isOpen}
      onClose={closeModal}
      onBack={closeModal}
      footer={
        <Button
          type="primary"
          text={
            isEqual(localConsents, manualConsents)
              ? t("action.continue")
              : t("action.save")
          }
          onClick={() => {
            if (!isEqual(localConsents, manualConsents)) {
              onSelectConsents?.(localConsents);
            }
            closeModal();
          }}
        />
      }
    >
      <CustomerConsent
        opportunityId={opportunityId}
        consentTypes={consentTypes}
        customer={customer ?? opportunityCustomer}
        departments={departments}
        manualConsents={localConsents}
        setManualConsents={setLocalConsents}
      />
    </ModalSheet>
  );
};
